module.exports = __webpack_public_path__ + "static/media/fl4.ec347aa8.jpg";